export const DESCRIPTION_MIN_HEIGHT = 1600;
